import React from 'react';
import { withRouter } from "react-router-dom";
import { Modal, Space, Input, Button, Tabs, Form, Row, Col, Radio, message, Checkbox } from 'antd';
import DataTable from './dataTable.tsx';
import '../../assets/styles/common.less';
import { addCustomPollutant, bindPollutantAndProject } from '../../apis/common'
import { checkProductd, checkDepthid } from '../../configs/checkProductId.js'

const { TabPane } = Tabs;

class popEditData extends React.Component {
  formRef = React.createRef();
  getdata = React.createRef();
  systemdata = React.createRef();
  
  state = {
    modal1Visible: false,
    modalPollute: false,
    printValue: '',
    ISKOC: true,
    tabs: 1,
    project_id: '',
    depth_id: ''
  };

  componentDidMount() {
    this.props.triggerRef(this);
    let productId = checkProductd();
    if (productId) {
      this.setState({ project_id: productId })
    }
    let Depthid = checkDepthid();
    if (Depthid) {
      this.setState({ depth_id: Depthid })
    }
  }

  setModal1Visible(modal1Visible) {
    this.setState({ modal1Visible })
    if (modal1Visible === false) {
      let selectRowIds = ''
      if (this.getdata.current) {
        selectRowIds += this.getdata.current.state.selectRowIds;
      }
      if (this.systemdata.current) {
        selectRowIds += this.systemdata.current.state.selectRowIds
      }
      if (selectRowIds.length > 0) {
        selectRowIds = selectRowIds.substr(0, selectRowIds.length - 1);
        bindPollutantAndProject({
          project_id: this.state.project_id,
          pollutant_ids: selectRowIds,
          depth_id: this.state.depth_id
        }).then((res) => {
          this.props.downProps()
        }).catch((err) => {
          message.warn('服务器异常，请稍后再试')
        })
      }
    }
  }

  addPollute(modalPollute) {
    this.setState({ modalPollute })
  }

  searchTable() {
    if (this.state.tabs == 1) {
      this.systemdata.current.systemPollutants({ keyword: this.state.printValue })
    } else if (this.state.tabs == 2) {
      this.getdata.current.definitionPollutants({ keyword: this.state.printValue })
    }
  }

  selectTabs(e) {
    this.setState({ tabs: e })
  }

  getChange(value) {
    let printValue = value.target.value;
    if (!printValue) {
      if (this.state.tabs == 1) {
        this.systemdata.current.systemPollutants({ keyword: '' })
      } else if (this.state.tabs == 2) {
        this.getdata.current.definitionPollutants({ keyword: '' })
      }
    }
    this.setState({ printValue })
  }

  changeRadio(i) {
    this.setState({
      ISKOC: i.target.value === '是'
    })
  }

  // 提交自定义污染物
  fnAddPollutant = async () => {
    try {
      // validateFields 会自动触发 rules 校验，若不通过会抛出异常进入 catch
      const values = await this.formRef.current.validateFields();
      
      addCustomPollutant({
        ...values
      }).then((res) => {
        message.success('添加成功');
        this.formRef.current.resetFields();
        this.setState({ modalPollute: false });
        if (this.getdata.current) {
          this.getdata.current.definitionPollutants();
        }
      }).catch((err) => {
        message.error('服务器异常，请稍后再试');
      })
    } catch (errorInfo) {
      // 校验失败逻辑，Ant Design 界面会自动提示错误信息
      console.log('Validate Failed:', errorInfo);
    }
  };

  render() {
    return (
      <div>
        <Modal
          title="添加系统污染物数据库"
          visible={this.state.modal1Visible}
          onOk={() => this.setModal1Visible(false)}
          onCancel={() => this.setModal1Visible(false)}
          cancelText="取消"
          okText="确定"
          width={1000}
          destroyOnClose={true}
        >
          <Space style={{ marginBottom: 16 }}>
            <Input 
              placeholder="请输入污染物中英文名或CAS编号" 
              size="large" 
              allowClear={true} 
              onChange={this.getChange.bind(this)} 
              style={{ width: 300 }}
            />
            <Button type="primary" onClick={this.searchTable.bind(this)} >
              搜索
            </Button>
          </Space>
          <Tabs defaultActiveKey="1" type="card" onChange={this.selectTabs.bind(this)} className="TabsClass">
            <TabPane tab="系统污染物数据库" key="1">
              <DataTable type="system" upprops={this} ref={this.systemdata}></DataTable>
            </TabPane>
            <TabPane tab="自定义污染物数据库" key="2">
              <div className="followbtn" style={{ marginBottom: 10 }}>
                <Button type="primary" className="addbtn" onClick={this.addPollute.bind(this, true)}>+ 添加</Button>
              </div>
              <DataTable type="definition" ref={this.getdata} upprops={this}></DataTable>
            </TabPane>
          </Tabs>
        </Modal>

        <Modal
          title="添加自定义污染物数据库"
          visible={this.state.modalPollute}
          onOk={this.fnAddPollutant}
          onCancel={() => this.addPollute(false)}
          cancelText="取消"
          okText="确定"
          width={1000}
          destroyOnClose={true}
        >
          <Form layout="vertical" ref={this.formRef} preserve={false}>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item 
                  label="中文名：" 
                  name="NAME_CN" 
                  rules={[{ required: true, message: '中文名不能为空' }]}
                >
                  <Input placeholder="必填" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item 
                  label="英文名：" 
                  name="NAME_EN" 
                  rules={[{ required: true, message: '英文名不能为空' }]}
                >
                  <Input placeholder="必填" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item 
                  label="CAS编号：" 
                  name="CAS_CODE" 
                  rules={[{ required: true, message: 'CAS编号不能为空' }]}
                >
                  <Input placeholder="必填" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="亨利常数(无量纲)：" name="HSTRIKE">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item label="亨利常数数据来源：" name="HSTRIKE_SOURCE">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="Da(cm²/s)：" name="DA">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="Da数据来源：" name="DA_SOURCE">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="Dw(cm²/s)：" name="DW">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item label="Dw数据来源：" name="DW_SOURCE">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="Koc/Kd数据来源：" name="ISKOC_SOURCE">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="溶解度(mg/L)：" name="S">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="溶解度数据来源：" name="S_SOURCE">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item label="Sfo(mg/kg-d)-1：" name="SFO">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="Sfo数据来源：" name="SFO_SOURCE">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="IUR(mg/m³)-1：" name="IUR">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="IUR数据来源：" name="IUR_SOURCE">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item label="RfDo(mg/kg-d)：" name="RFDO">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="RfDo数据来源：" name="RFDO_SOURCE">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="RfC(mg/m³)：" name="RFC">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="RfC数据来源：" name="RFC_SOURCE">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item label="ABSgi(无量纲)：" name="ABSGI">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="ABSgi数据来源：" name="ABSGI_SOURCE">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="ABSd(无量纲)：" name="ABSD">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="ABSd数据来源：" name="ABSD_SOURCE">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            <Row className='atoms_Row_span' gutter={24}>
              <Col span={6}>
                <Form.Item label="Carbon atoms (n)：" name="CARBON">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="Hydrogen atoms (m)：" name="HYDROGEN">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="Oxygen atoms (m)：" name="OXYGEN">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="Factor δ [g/g]：" name="STOICHIOMETRIC">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item label="反应常数：" name="KOBS">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="是否VOC：" name="ISVOC">
                  <Radio.Group defaultValue={'是'}>
                    <Radio value={'是'}>是</Radio>
                    <Radio value={'否'}>否</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              {
                this.state.ISKOC ? (
                  <Col span={6}>
                    <Form.Item label="Koc(cm³/g)：" name="KOC">
                      <Input />
                    </Form.Item>
                  </Col>
                ) : (
                  <Col span={6}>
                    <Form.Item label="Kd(cm³/g)：" name="KD">
                      <Input />
                    </Form.Item>
                  </Col>
                )
              }
              <Col span={6}>
                <Form.Item label="是否基于Koc计算Kd：" name="ISKOC">
                  <Radio.Group defaultValue={'是'} onChange={this.changeRadio.bind(this)}>
                    <Radio value={'是'}>是</Radio>
                    <Radio value={'否'}>否</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default withRouter(popEditData);